import { RtCarHotList } from './rt-car-hot-list';
import { RtTripComment } from './rt-trip-comment';

export class RtTripCommentDialogModel {
    title: string;
    tripComment: RtTripComment | RtCarHotList;
}
